import React from 'react';

function Projetos() {
    return (
        <div className="m-5 projetos-container">
            <h2>Curadoria de Projetos no Instituto Pasqualin</h2>
            <br></br>
            <p className="fw-bold">Potencializando Ideias, Transformando Realidades</p>

            <span>O Instituto Pasqualin acredita que a transformação social exige a articulação de projetos inovadores que dialoguem com as demandas urgentes da sociedade.
                Nesse sentido, desenvolvemos a Curadoria de Projetos, um serviço que atua como ponte entre ideias e práticas, oferecendo suporte técnico, ético e
                estratégico para iniciativas que promovam justiça social, equidade e direitos humanos.</span>

            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">O que é a Curadoria de Projetos?</p>

            <span>A Curadoria de Projetos é um espaço colaborativo destinado a apoiar profissionais, organizações, escolas e comunidades na concepção, desenvolvimento e implementação de projetos que tenham impacto social positivo.
                Nosso objetivo é oferecer suporte metodológico e teórico para que iniciativas sejam construídas de forma crítica, participativa e alinhada aos valores que fundamentam o Instituto Pasqualin.</span>

            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Nossos Diferenciais</p>

            <ol>
                <li><strong>Abordagem crítica:</strong> Os projetos são analisados e orientados a partir de uma perspectiva que questiona desigualdades estruturais e privilegia práticas emancipatórias.</li>
                <li><strong>Apoio personalizado:</strong> Oferecemos consultoria específica para cada projeto, considerando as particularidades de seu contexto e público-alvo.</li>
                <li><strong>Articulação interdisciplinar:</strong> Incorporamos saberes diversos, promovendo diálogos entre Psicologia, Educação, Direitos Humanos e outras áreas do conhecimento.</li>
                <li><strong>Foco em impacto social:</strong> Priorizamos projetos que promovam transformações concretas, alinhados com os princípios de equidade e inclusão.</li>
            </ol>


            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Como Funciona?</p>

            <ol>
                <li><strong>Diagnóstico Inicial:</strong> Realizamos um encontro para entender o propósito, os desafios e o impacto esperado do projeto.</li>
                <li><strong>Análise Crítica:</strong> Revisamos a proposta à luz de referenciais teóricos, práticas inclusivas e metodologias participativas.</li>
                <li><strong>Co-criação:</strong> Trabalhamos junto aos proponentes para ajustar, aprofundar e potencializar o projeto, garantindo sua coerência com princípios éticos e sociais.</li>
                <li><strong>Acompanhamento e Monitoramento:</strong> Oferecemos suporte durante a implementação e avaliamos os resultados, promovendo ajustes contínuos para maximizar o impacto.</li>
            </ol>

            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Exemplos de Projetos que Curamos</p>

            <ul>
                <li><strong>Educação inclusiva e equidade racial:</strong> Projetos voltados para a formação de educadores e gestores escolares no enfrentamento do racismo e promoção da diversidade.</li>
                <li><strong>Promoção de saúde mental nas escolas:</strong> Iniciativas que desenvolvem estratégias de acolhimento e cuidado emocional para estudantes e professores.</li>
                <li><strong>Gênero e sexualidade:</strong> Projetos que valorizam a diversidade sexual e de gênero, criando ambientes educativos seguros e acolhedores para todas as identidades.</li>
                <li><strong>Direitos humanos e cidadania:</strong> Ações que empoderam comunidades na luta por seus direitos e na superação de barreiras sociais.</li>
            </ul>

            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Por que aderir à nossa Curadoria?</p>

            <ul>
                <li><strong>Impacto ampliado:</strong> Projetos bem estruturados e fundamentados têm maior alcance e efetividade.</li>
                <li><strong>Apoio técnico qualificado:</strong> Contamos com uma equipe interdisciplinar experiente em práticas críticas e transformadoras.</li>
                <li><strong>Rede de conexões:</strong> Facilitamos parcerias e articulações que fortalecem os projetos e garantem sua sustentabilidade.</li>
            </ul>

            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Quem pode participar? </p>

            <ul>
                <li><strong>Educadores e gestores escolares.</strong></li>
                <li><strong>Psicólogos e outros profissionais da saúde.</strong></li>
                <li><strong>Organizações sociais, ONGs e coletivos.</strong></li>
                <li><strong>Comunidades e lideranças locais.</strong></li>
                <li><strong>Estudantes e pesquisadores interessados em promover impacto social.</strong></li>
            </ul>
            
            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Nosso Convite</p>

            <span>A Curadoria de Projetos do Instituto Pasqualin é um espaço para sonhar, construir e transformar. Se você tem uma ideia ou iniciativa que pode mudar vidas e contribuir para uma sociedade mais justa, estamos aqui para caminhar ao seu lado.</span>
            <p className="mt-1"><span className="fw-bold">Venha cocriar conosco!</span> Vamos juntos potencializar projetos que coloquem a equidade, a diversidade e os direitos humanos no centro das transformações sociais.</p>


        </div>
    );
}

export default Projetos;
